export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["ANTRPAY"] = "antrpay";
    PaymentMethod["CARD"] = "card";
    PaymentMethod["COINPAYMENTS"] = "coinpayments";
    PaymentMethod["DIRECTA24"] = "directa24";
    PaymentMethod["INWIZO_ECOM"] = "inwizo_ecom";
    PaymentMethod["INWIZO_SBP"] = "inwizo_sbp";
    PaymentMethod["INWIZO_TPAY"] = "inwizo_tpay";
    PaymentMethod["LUXFIN"] = "luxfin";
    PaymentMethod["PAYOK"] = "payok";
    PaymentMethod["PAYPORT"] = "payport";
    PaymentMethod["UPGATE_ALIPAY"] = "ug_alipay";
    PaymentMethod["UPGATE_KAKAO"] = "ug_kakao";
    PaymentMethod["UPGATE_UPI"] = "ug_upi";
    PaymentMethod["VOLT"] = "volt";
    PaymentMethod["FPAY_ALIPAY"] = "fpay_alipay";
    PaymentMethod["FPAY_WECHAT"] = "fpay_wechat";
    PaymentMethod["OVERPAY"] = "overpay";
    PaymentMethod["PAYSSION_GCASH_PH"] = "payssion_gcash_ph";
    PaymentMethod["PAYSSION_PAYMAYA_PH"] = "payssion_paymaya_ph";
    PaymentMethod["PAYSSION_CARD_RU"] = "payssion_card_ru";
    PaymentMethod["PAYSSION_SBP_RU"] = "payssion_sbp_ru";
    PaymentMethod["PAYSSION_TBANK_RU"] = "payssion_tbank_ru";
    PaymentMethod["PAYSSION_YOOMONEY_RU"] = "payssion_yoomoney_ru";
    PaymentMethod["PAYSSION_SBERPAY_RU"] = "payssion_sberpay_ru";
    PaymentMethod["PAYSSION_KAKAOPAY_KR"] = "payssion_kakaopay_kr";
    PaymentMethod["PAYSSION_SAMSUNGPAY_KR"] = "payssion_samsungpay_kr";
    PaymentMethod["PAYSSION_VIETQR_VN"] = "payssion_vietqr_vn";
    PaymentMethod["PAYSSION_STCPAY_SA"] = "payssion_stcpay_sa";
    PaymentMethod["PAYSSION_APPLEPAY_SA"] = "payssion_applepay_sa";
    PaymentMethod["PAYSSION_ENETS_SG"] = "payssion_enets_sg";
    PaymentMethod["PAYSSION_PAYNOW_SG"] = "payssion_paynow_sg";
    PaymentMethod["DUKPAY_SBP_RU"] = "dukpay_sbp_ru";
    PaymentMethod["DUKPAY_SBERPAY_RU"] = "dukpay_sberpay_ru";
    PaymentMethod["DUKPAY_TBANK_RU"] = "dukpay_tbank_ru";
    PaymentMethod["DUKPAY_YOOMONEY_RU"] = "dukpay_yoomoney_ru";
    PaymentMethod["DUKPAY_CARD_RU"] = "dukpay_card_ru";
    PaymentMethod["STIXRAMP_CASH_APP_US"] = "stixramp_cash_app_us";
    PaymentMethod["STIXRAMP_PAYPAL_US"] = "stixramp_paypal_us";
})(PaymentMethod || (PaymentMethod = {}));
export var CardBrand;
(function (CardBrand) {
    CardBrand["VISA"] = "visa";
    CardBrand["DISCOVER"] = "discover";
    CardBrand["MASTER"] = "master";
})(CardBrand || (CardBrand = {}));
